export class Promotion {
  constructor(
    public id: number,
    public name: string
  ) { }
}
